mutation NavigationSwitch($input: NavigationSwitchInput!) {
    navigationSwitch(input: $input) {
        isNewNavigation
    }
}
